module.exports = __webpack_public_path__ + "static/media/plus-white.40b1d90f.svg";